import { OnboardingState } from '@repo/domain/user';
import {
  BASE_ONBOARDING,
  type OnboardingStepConfig,
} from '@repo/onboarding/onboarding-store';

const showOnboardingModal = (step: OnboardingStepConfig): boolean => {
  if (!step?.name) {
    return false;
  }
  return (
    step.name === BASE_ONBOARDING[OnboardingState.SignUp].name ||
    step.name === BASE_ONBOARDING[OnboardingState.WhatDescribesYou].name ||
    step.name === BASE_ONBOARDING[OnboardingState.HearAboutUs].name ||
    step.name === BASE_ONBOARDING[OnboardingState.HowExperienced].name ||
    step.name === BASE_ONBOARDING[OnboardingState.CreateFirst].name
  );
};

export const isInWebsiteOnboarding = (
  step: OnboardingStepConfig | null
): boolean => {
  if (!step?.name) {
    return false;
  }
  if (showOnboardingModal(step)) {
    return true;
  }
  return step.name === BASE_ONBOARDING[OnboardingState.ChooseTemplate].name;
};
